module.exports = __webpack_public_path__ + "static/app-key-13b5b1cac5a3821523c41945583fc494.png";